const routes = [
    {
        path: "/housing/tenant",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "housingtenant_index"
        }
    }
]

export default routes;
